import Button from '../../components/bootstrap/Button';
import FormGroup from '../../components/bootstrap/forms/FormGroup';
import Input from '../../components/bootstrap/forms/Input';
import Textarea from '../../components/bootstrap/forms/Textarea';
import Page from '../../layout/Page/Page';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';

const ContactPage = () => {
	const handleSendMail = () => {
		// TODO
		const name = (document.getElementById('contactName') as HTMLInputElement).value;
		const email = (document.getElementById('contactEmail') as HTMLInputElement).value;
		const subject = (document.getElementById('contactSubject') as HTMLInputElement).value;
		const message = (document.getElementById('contactMessage') as HTMLTextAreaElement).value;

		const mailtoLink = `mailto:tam.nguyenduc@omsandbox.co?subject=${encodeURIComponent(
			subject,
		)}&body=${encodeURIComponent(`Name: ${name}\nEmail: ${email}\n\n${message}`)}`;

		window.location.href = mailtoLink;
	};

	return (
		<PageWrapper title='Contact Us' isProtected={false}>
			<Page>
				<div className='row d-flex justify-content-center flex-grow-1'>
					<div className='col-md-8 col-lg-6'>
						<div className='text-center h2 fw-bold mb-4'>Contact Us</div>
						<form className='row g-4'>
							<FormGroup id='contactName' label='Your Name'>
								<Input type='text' placeholder='Enter your name' />
							</FormGroup>
							<FormGroup id='contactEmail' label='Your Email'>
								<Input type='email' placeholder='Enter your email' />
							</FormGroup>
							<FormGroup id='contactSubject' label='Subject'>
								<Input type='text' placeholder='Subject of your message' />
							</FormGroup>
							<FormGroup id='contactMessage' label='Message'>
								<Textarea rows={5} placeholder='Your message here...' />
							</FormGroup>
							<div className='d-grid'>
								<Button color='primary' onClick={handleSendMail}>
									Send Message
								</Button>
							</div>
						</form>
					</div>
				</div>

				<div className='row d-flex justify-content-center'>
					<div className='col-md-8 col-lg-6'>
						<div className='text-center h2 fw-bold mb-4'>Contact Information</div>
						<div className='card'>
							<div className='card-body'>
								<p className='card-text'>
									<strong>Name:</strong> Nguyen Duc Tam
								</p>
								<p className='card-text'>
									<strong>Email:</strong>{' '}
									<a href='mailto:tam.nguyenduc@omsandbox.co'>
										tam.nguyenduc@omsandbox.co
									</a>
								</p>
								<p className='card-text'>
									<strong>Phone:</strong> (+84) 899088671
								</p>
							</div>
						</div>
					</div>
				</div>
				<div className='row d-flex justify-content-center mb-4'>
					<div className='col-12 d-flex flex-column justify-content-center align-items-center'>
						<Button
							className='px-5 py-3'
							color='primary'
							isLight
							icon='HolidayVillage'
							tag='a'
							href='/'>
							Homepage
						</Button>
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default ContactPage;
